var Theme = Theme || {};
Theme.Utilities = Theme.Utilities || {};

Theme.Utilities.YouTube = (function ($) {
    var videoData = [];

    return {
        init: _init
    };

    function _init() {
        if ($('.youtube-embed').length) {
            loadYouTubeAPI();
        }        
    }    

    function createYouTubePlayer(videoId, containerId) {
        return new YT.Player(containerId, {
            videoId: videoId,
            events: {
                'onStateChange': function (event) {
                    if (event.data == YT.PlayerState.PLAYING) {
                        if (!$('#' + containerId).data('played')) {
                            SCM.ClientStatsMaster.logPlayActionStats($('#' + containerId));
                            $('#' + containerId).data('played', true);
                        }
                    }
                }
            }
        });
    }

    function loadYouTubeAPI() {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
        var youtubeIframes = document.getElementsByClassName("youtube-embed");

        Array.prototype.forEach.call(youtubeIframes, function (youtubeIframe) {
            var src = youtubeIframe.getAttribute("src");
            var partsArr = src.split("/");
            var videoSource = partsArr[partsArr.length - 1].split("?");
            var videoId = videoSource[videoSource.length - 2];
            var containerId = 'player-container-' + videoId;
            youtubeIframe.id = containerId;

            videoData.push({
                videoId: videoId,
                containerId: containerId
            });;
        });
        // Callback function when the YouTube API is ready
        window.onYouTubeIframeAPIReady = function () {
            videoData.forEach(function (data) {
                createYouTubePlayer(data.videoId, data.containerId);

            });
        };
    }
})(jQuery);